import { gql } from 'graphql-tag';
import type { TypedDocumentNode } from '@apollo/client';
import type { IGetSignInTicketActivityData, IGetSignInTicketActivityVars } from '../types';

export const GET_SIGN_IN_TICKET_ACTIVITY: TypedDocumentNode<
  IGetSignInTicketActivityData,
  IGetSignInTicketActivityVars
> = gql`
  query getSignInTicketActivityQuery($input: ReadSignInTicketActivityInput!) {
    getSignInTicketActivity(input: $input) {
      lastName
      firstName
      username
      lastPrintedOn
    }
  }
`;
